import React, {useState} from "react";
import PhoneNumber from "./PhoneNumber";
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import UseForm from "./UseForm";
import {validator} from "./Validator";
import {BootstrapDialog} from "../FormComopents/Form/CustomDialog"
import {bgColors} from "../utils/bgColor";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import UseWindowDimensions from '../screensizecontainer/windowdimensions';
import AuthFormHeader from "./AuthFormHeader"
import { DialogActions, DialogContent} from "@mui/material";
import Registeruser from "./Services/Registeruser"
const Signup=(props)=> {
  const {openSignup, onCLickOpenSignin}= props
    const {height, width} = UseWindowDimensions()
    const initState = {
      user_name:"",
      first_name:"",
      last_name:"",
      organization_name:"",
      phone_no:"",
      email_id:"",
      password: "",
      confirmpassword: "",
    };

      const submit = () => {
        return ("Submited")
      };

      const {
        handleChange,
        handleSubmit,
        handleBlur,
        state,
        errors,
        countryCode
      } = UseForm({
        initState,
        callback: submit,
        validator
      });

      let isValidForm =
        Object.values(errors).filter(error => typeof error !== "undefined")
      .length === 0;

    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordHide = () => {
         setShowPassword((show) => !show);
    };    
    // let _error = []
    // let _result = []
    const submitSignupData = (e) => {
      e.preventDefault()
       Registeruser(state)
    }


  return (
    <Box sx = {{height:height, width:width, borderRadius:10}}>    
    <BootstrapDialog
    // onClose={() => dispatch(closeUserFolio)}
    aria-labelledby="customized-dialog-title"
    // open={openUserFolio}
    open={openSignup}

    scroll="paper"
    sx={{
        "& .MuiDialog-container": {
           alignItems: "flex-start",
           "& .MuiPaper-root": {
                  width: "100%",
                  minHeight:"200px",
                  // marginTop:'0.25rem',
                  // marginLeft:'0.5rem',
                  maxWidth: '300px'  // Set your width here
              
                },
        },
     }}
    
    PaperProps={{
       style:{borderRadius: 10,
       background:bgColors.default_backgroun_grey
    }}}
    >
      <AuthFormHeader/>
      <DialogContent 
       sx={{ 
        maxHeight: '100%', 
        maxWidth: 300, padding:'1rem', 
        background:bgColors.grey_100
        }} 
      >
        <form onSubmit={handleSubmit}>
        <Grid container spacing={2} display={"flex"} direction={"column"}>
            <Grid item>
            <TextField
                required
                fullWidth
                size = 'small'
                label="User name"
                name="user_name"
                //   className={margin}
                defaultValue={state.user_name}
                onChange={handleChange}
                error={errors.user_name ? true : false}
                helperText={errors.user_name}
                onBlur={handleBlur}
            />
            </Grid>
            <Grid item>
            <TextField
                required
                fullWidth
                size = 'small'
                label="First name"
                name="first_name"
                //   className={margin}
                defaultValue={state.user_name}
                onChange={handleChange}
                error={errors.user_name ? true : false}
                helperText={errors.user_name}
                onBlur={handleBlur}
            />
            </Grid>
            <Grid item>
            <TextField
                required
                fullWidth
                size = 'small'
                label="Last name"
                name="last_name"
                //   className={margin}
                defaultValue={state.user_name}
                onChange={handleChange}
                error={errors.user_name ? true : false}
                helperText={errors.user_name}
                onBlur={handleBlur}
            />
            </Grid>
        <Grid item>
        <TextField
            required
            fullWidth
            size = 'small'
            label="Organization"
            name="organization_name"
            //   className={margin}
            defaultValue={state.organization_name}
            onChange={handleChange}
            error={errors.organization_name ? true : false}
            helperText={errors.organization_name}
            onBlur={handleBlur}
        />
        </Grid>
          <Grid item>
          <TextField
            required
            fullWidth
            size = 'small'
            label="Email_id"
            name="email_id"
            defaultValue={state.email_id}
            onChange={handleChange}
            error={errors.email_id ? true : false}
            helperText={errors.email_id}
            onBlur={handleBlur}
          />
        </Grid>
        <Grid item>
        <PhoneNumber
          errors={errors}
          state={state}
          handleChange={handleChange}
          handleBlur={handleBlur}
          countryCode={countryCode}
        />
        </Grid>    
      <Grid item>
      <TextField
          required
          fullWidth
          name = "password"
          label = "Password"
          type = { showPassword ? "text" : "password" }
          id = "password"
          size = "small"
          autoComplete = "current-password"
          onChange = {handleChange}
          error={errors.password ? true : false}
          helperText={errors.password}
          // defaultValue = {state.password }
          onBlur={handleBlur}
          InputProps = {
          {
              endAdornment: ( 
              <InputAdornment position="end"> {
                  showPassword ? ( 
                  <Visibility className = "cursor_pointer"
                  onClick = {
                      togglePasswordHide
                  }
                  />
                  ) : ( 
                  <VisibilityOff onClick = {
                      togglePasswordHide
                  }
                  />)} 
              </InputAdornment>
              ),}}
              />
          </Grid>

          <Grid item>

          <TextField
          required
          fullWidth
          name = "confirmpassword"
          label = "Confirmpassword"
          type="password"
          // type = { showPassword ? "text" : "confirmpassword" }
          id = "confirmpassword"
          size = "small"
          autoComplete = "current-confirmpassword"
          onChange = {handleChange}
          error={errors.confirmpassword ? true : false}
          helperText={errors.confirmpassword}
          onBlur={handleBlur}
              />
          </Grid>

          {/* <Grid item> */}
      {/* <TextField
          required
          fullWidth
          name = "confirmpassword"
          label = "Confirmpassword"
          type = { showconfirmPassword ? "text" : "confirmpassword" }
          id = "confirmpassword"
          size = "small"
          autoComplete = "current-password"
          onChange = {handleChange}
          error={errors.confirmpassword ? true : false}
          helperText={errors.confirmpassword}
          // defaultValue = {state.password }
          onBlur={handleBlur}
          InputProps = {
          {
              endAdornment: ( 
              <InputAdornment position="end"> {
                  showconfirmPassword ? ( 
                  <Visibility className = "cursor_pointer"
                  onClick = {
                      toggleConfimrPasswordHide
                  }
                  />
                  ) : ( 
                  <VisibilityOff onClick = {
                    toggleConfimrPasswordHide
                  }
                  />)} 
              </InputAdornment>
              ),}}
              />
          </Grid> */}
          
        </Grid>
        </form>
    </DialogContent>

    <DialogActions>
    <Grid container spacing={2} display={"flex"} direction={"column"}>
    <Grid item>
            <Button
              fullWidth
              size= 'small'
              disabled={!isValidForm}
              type="submit"
              variant="contained"
              color="primary"
              onClick={submitSignupData}
            //   className={margin}
            >
            Signup
          </Button>
        </Grid>
         <Grid container display={'flex'} spacing={1} direction={'column'}>
        <Grid item> 
        <Grid container  display={'flex'} direction={'column'}
         justifyContent={'centre'}
         alignItems="center"
        >
         <Grid item>
          
              <Link href="#login" 
              onClick={onCLickOpenSignin}
              >
               <Typography 
        sx ={{
            fontSize: 14, 
             fontWeight:'bold',
             fontFamily:'serif',
             padding:'0.25rem'
             }}
          >{"Login"}
        </Typography> 
         </Link>
        </Grid>
          </Grid>
          </Grid>
          </Grid>
          </Grid>
    </DialogActions>
    </BootstrapDialog>
</Box>

)}
export default Signup
